import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'slugify' })
export class SlugifyPipe implements PipeTransform {
	public transform(input: string, format: '-' | '_' = '-'): string {
		if (!input) { return input; }

		return input.toString().toLowerCase()
			.replace(/\s+/g, format)				// Replace spaces with -
			.replace(/[^a-zA-Z0-9]+/g, format) 	// Remove all non-word chars
			.replace(new RegExp(`${format}+`, 'g'), format)				// Replace multiple - with single -
			.replace(new RegExp(`^${format}+`), '')		// Trim - from start of text
			.replace(new RegExp(`${format}+$`), '');	// Trim - from end of text
	}
}
